import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

export const SpacePostDetailSkeleton: FC = () => (
  <Box sx={{ p: 2, maxWidth: 800, mx: 'auto' }}>
    {/* Back link */}
    <Box display="flex" alignItems="center" gap={1} mb={2}>
      <Skeleton variant="circular" width={20} height={20} />
      <Skeleton variant="text" width={120} height={18} />
    </Box>

    {/* Post card */}
    <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, p: 2.5 }}>
      {/* Author row + pinned badge */}
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton variant="text" width={120} height={18} />
            <Skeleton variant="text" width={50} height={14} />
          </Box>
        </Box>
        <Skeleton variant="rectangular" width={68} height={24} sx={{ borderRadius: 11 }} />
      </Box>

      {/* Post title */}
      <Skeleton variant="text" width="55%" height={22} sx={{ mb: 1.5 }} />

      {/* Post body — multi-paragraph */}
      {[100, 95, 88, 0, 100, 92, 85, 78, 0, 100, 90].map((w, i) =>
        w === 0 ? (
          // oxlint-disable-next-line react/no-array-index-key
          <Box key={i} height={10} />
        ) : (
          // oxlint-disable-next-line react/no-array-index-key
          <Skeleton key={i} variant="text" width={`${w}%`} height={16} />
        ),
      )}

      {/* Reactions row */}
      <Box display="flex" alignItems="center" gap={2} mt={2.5} mb={2}>
        <Skeleton variant="text" width={60} height={16} />
        <Skeleton variant="rectangular" width={46} height={22} sx={{ borderRadius: 11 }} />
      </Box>

      {/* Comment input */}
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 1.5 }}>
        {/* Toolbar */}
        <Box display="flex" gap={1} mb={1}>
          <Skeleton variant="rectangular" width={28} height={24} sx={{ borderRadius: 0.5 }} />
          <Skeleton variant="rectangular" width={28} height={24} sx={{ borderRadius: 0.5 }} />
        </Box>
        <Skeleton variant="text" width={140} height={18} />
        <Box height={32} />
        {/* Bottom row */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={28} height={28} />
        </Box>
      </Box>
    </Box>
  </Box>
);
